import React from 'react';
import { useAppPricingPlan } from "../hooks";
import { BILLING_CYCLE_FOR_HOSTING, DEFAULT_ERROR_MESSAGE_PRICING_FAILED } from "../PricingTab.constants";
import PricingCalculatorSkeleton from "./PricingCalculatorSkeleton";

var PricingCalculator = function PricingCalculator(_ref) {
  var appId = _ref.appId,
      hosting = _ref.hosting,
      mpacBaseUrl = _ref.mpacBaseUrl;
  var applicableBillingCycle = BILLING_CYCLE_FOR_HOSTING[hosting];

  var _useAppPricingPlan = useAppPricingPlan({
    appId: appId,
    hosting: hosting,
    mpacBaseUrl: mpacBaseUrl,
    billingCycle: applicableBillingCycle
  }),
      loading = _useAppPricingPlan.loading,
      data = _useAppPricingPlan.data,
      error = _useAppPricingPlan.error;

  if (error) {
    return /*#__PURE__*/React.createElement("div", null, DEFAULT_ERROR_MESSAGE_PRICING_FAILED);
  }

  if (!data && loading) {
    return /*#__PURE__*/React.createElement(PricingCalculatorSkeleton, null);
  } // Pricing Calculator to be written as part of AMKT-25492


  return null;
};

export default PricingCalculator;